// extracted by mini-css-extract-plugin
export default {"fiveStars":"FiveStars_fiveStars__2l5bI","fiveStars__stars":"FiveStars_fiveStars__stars__oaABy"};